import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedUser: null,
  messages: [],
  activeUsers: [],
  isTyping: null,
  unreadMessages: {} // { userId: count }
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
      state.messages = []; // Clear messages when switching users
    },
    setActiveUsers: (state, action) => {
      state.activeUsers = action.payload;
    },
    addUnreadMessages: (state, action) => {
      const { userId, count } = action.payload;
      // Add to existing count if any
      state.unreadMessages[userId] = (state.unreadMessages[userId] || 0) + count;
    },
    addMessage: (state, action) => {
      const newMessage = action.payload;
      const exists = state.messages.some(msg => msg._id === newMessage._id);
      
      if (!exists) {
        state.messages.push(newMessage);
        
        // Handle unread messages counter only for received messages
        if (newMessage.receiver === newMessage.currentUserId) {
          // Only increment if message is not from currently selected user
          if (!state.selectedUser || newMessage.sender !== state.selectedUser.userId) {
            const senderId = newMessage.sender;
            state.unreadMessages[senderId] = (state.unreadMessages[senderId] || 0) + 1;
          }
        }
      }
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    updateMessageReadStatus: (state, action) => {
      const { messageId, readAt } = action.payload;
      const message = state.messages.find(msg => msg._id === messageId);
      if (message) {
        message.read = true;
        message.readAt = readAt;
      }
    },
    resetChat: (state) => {
      state.selectedUser = null;
      state.messages = [];
      state.activeUsers = [];
      state.isTyping = null;
      // Don't reset unreadMessages here
    },
    clearUnreadMessages: (state, action) => {
      const userId = action.payload;
      delete state.unreadMessages[userId];
    }
  }
});

export const { 
  setSelectedUser, 
  setActiveUsers, 
  addMessage, 
  setMessages,
  updateMessageReadStatus,
  resetChat,
  clearUnreadMessages,
  addUnreadMessages
} = chatSlice.actions;

export default chatSlice.reducer;





